<script lang="ts">
	import { createEventDispatcher, onDestroy } from 'svelte'

	export let threshold = 0
	export let horizontal = false
	export let elementScroll: any = undefined
	export let hasMore = true
	export let reset = true

	const dispatch = createEventDispatcher()
	let component: any
	let isLoadMore = false

	$: {
		if (reset) {
			if (component || elementScroll) {
				const element = elementScroll ? elementScroll : component.parentNode
				element.scrollTop = 0
			}
			isLoadMore = false
			hasMore = true
			reset = false
		}
	}

	$: {
		//console.log("infinite - component, elementScroll: ", component, elementScroll)

		if (component || elementScroll) {
			const element = elementScroll ? elementScroll : component.parentNode

			element.addEventListener('scroll', onScroll)
			element.addEventListener('resize', onScroll)
		}
	}

	const onScroll = (e: any) => {
		// const element = e.target

		const offset = horizontal
			? e.target.scrollWidth - e.target.clientWidth - e.target.scrollLeft
			: e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop

		//console.log("infinite - offset ,threshold, isLoadMore, hasMore :", offset ,threshold, isLoadMore, hasMore)

		if (offset <= threshold) {
			if (!isLoadMore && hasMore) {
				dispatch('loadMore')
			}
			isLoadMore = true
		} else {
			isLoadMore = false
		}
	}

	onDestroy(() => {
		if (component || elementScroll) {
			const element = elementScroll ? elementScroll : component.parentNode

			element.removeEventListener('scroll', null)
			element.removeEventListener('resize', null)
		}
	})
</script>

<div bind:this={component} style="width:0px" />
